import { render, staticRenderFns } from "./SaveQuestionFeedbackModal.vue?vue&type=template&id=5237aa69&scoped=true&"
import script from "./SaveQuestionFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./SaveQuestionFeedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveQuestionFeedbackModal.vue?vue&type=style&index=0&id=5237aa69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5237aa69",
  null
  
)

export default component.exports